module.exports = __webpack_public_path__ + "static/media/search.04b93ef6.svg";